import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Box, Typography, CircularProgress } from '@mui/material';
import { headingBlue } from '../../../assets/colors';

const WORKersCategoryPieChart = ({ data, loader }) => {
  const committed = Number(data?.committed || 0);
  const uncommitted = Number(data?.uncommitted || 0);
  const unassigned = Number(data?.unassigned || 0);
  const total = data?.total !== undefined ? Number(data.total) : committed + uncommitted + unassigned;

  const chartSeriesData = [
    {
      name: 'Committed WORKers',
      y: committed,
      color: '#2e7d32' // green
    },
    {
      name: 'Supported WORKer',
      y: uncommitted,
      color: '#ed683c' // orange
    },
    {
      name: 'Uncategorized',
      y: unassigned,
      color: '#294b82' // headingBlue
    }
  ];

  const chartOptions = {
    chart: {
      type: 'pie',
      height: 350,
      backgroundColor: 'transparent'
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    tooltip: {
      headerFormat: '',
      pointFormat: '<span style="color:{point.color}">\u25CF</span> <b>{point.name}</b><br/>Count: <b>{point.y}</b> ({point.percentage:.1f}%)'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        innerSize: '55%',
        showInLegend: true,
        dataLabels: {
          enabled: true,
          format: '{point.y} ({point.percentage:.0f}%)',
          distance: 12,
          style: {
            fontSize: '0.75rem',
            fontWeight: '500',
            textOutline: 'none',
            color: '#333'
          }
        }
      }
    },
    legend: {
      enabled: true,
      align: 'center',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemStyle: {
        fontSize: '0.75rem',
        fontWeight: 'normal',
        color: '#444'
      },
      labelFormatter: function () {
        return `${this.name}: <b>${this.y}</b>`;
      }
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 420
          },
          chartOptions: {
            plotOptions: {
              pie: {
                dataLabels: {
                  enabled: false
                }
              }
            },
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom',
              itemStyle: {
                fontSize: '0.7rem'
              }
            }
          }
        }
      ]
    },
    series: [
      {
        name: 'WORKers',
        colorByPoint: true,
        data: chartSeriesData
      }
    ]
  };

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 1, pt: 0.5, pb: 0.5 }}>
        <Typography sx={{ color: headingBlue, fontSize: '1rem', fontWeight: 600 }}>
          WORKer Category Distribution
        </Typography>
        <Typography sx={{ color: '#555', fontSize: '0.85rem', fontWeight: 500 }}>
          Total: {total.toLocaleString()}
        </Typography>
      </Box>

      {loader ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 350 }}>
          <CircularProgress size={36} sx={{ color: headingBlue }} />
        </Box>
      ) : total === 0 ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 350 }}>
          <Typography sx={{ color: '#888', fontSize: '0.9rem' }}>
            No category distribution data available.
          </Typography>
        </Box>
      ) : (
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      )}
    </Box>
  );
};

export default WORKersCategoryPieChart;
